import { DrawerObject } from '../../../../components/drawer/drawer.types';
import { FormBuilderComponent } from '../../../../components/form-builder/form-builder.component';
import { DynamicForm } from '../../../../components/form-builder/form-builder.types';
import { RefParamRepository } from '../../../../store/ref-param-state/ref-param-state.repository';

interface getRefParamsAddDrawerObjectProps {
  store?: RefParamRepository;
  formObject?: DynamicForm;
  toggleVisibility?: () => void;
  action?: () => void;
}

export const getRefParamsAddDrawerObject = ({ store, formObject, toggleVisibility, action }: getRefParamsAddDrawerObjectProps): DrawerObject => {
  return {
    title: 'settings.refParams.addTitle',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: formObject,
      },
    },
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.refParams.form.submit',
        onClick: () => action?.(),
      },
      {
        label: 'settings.refParams.form.cancel',
        onClick: () => {
          toggleVisibility?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
